import React, { PropTypes } from "react";

export default function Dropdown({ choices, value, placeholder, availableChoices, onChange }) {
    const currentValue = value && choices[value] ? choices[value] : placeholder;
    const placeholderNode = (<a
      href="#placeholder" className="dropdown-item" key="-placeholder-" onClick={(event) => {
          event.preventDefault();
          onChange(null);
      }}
    >{placeholder}</a>);
    const options = Object.keys(choices).map(key => (<a
      key={key}
      href={`#${key}`}
      className={`dropdown-item${availableChoices && !availableChoices[key] ? " disabled" : ""}`}
      onClick={(event) => {
          event.preventDefault();
          onChange(key);
      }}
    >{choices[key]}</a>));

    return (
      <div className="btn-group btn-dropdown-group btn-block">
        <button type="button" className="btn btn-dropdown btn-dropdown-label" data-toggle="dropdown">
          {currentValue}
        </button>
        <button className="btn btn-dropdown dropdown-toggle" type="button" data-toggle="dropdown">
          <span className="sr-only">Toggle Dropdown</span>
        </button>
        <div className="dropdown-menu">
          {placeholder ? placeholderNode : null}
          {options}
        </div>
      </div>
    );
}

Dropdown.propTypes = {
    availableChoices: PropTypes.shape({}),
    choices: PropTypes.shape({}).isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Atoms/Dropdown.jsx